import { AdpImportFileDefinitionSelectResponse, AdpImportFileDefinitionResponse } from "@herbjoy/apex-api-models";
import { IComponentOptions } from "angular";
import { AdpExportFormat, AdpExportFormatSelection } from "../../../../core/services/data-services/adp-config.service";
import { CancelValue, ValueEmitter } from "../../../shared/modals/modal-types";
import templateUrl from "./adp-import-file-exporter-modal.component.html";

export interface ModalResolves {
    payrollID: number;
    exportFormats: AdpExportFormatSelection[];
    earningsCodeDefinitions: AdpImportFileDefinitionSelectResponse[];
    defaultFormat: AdpImportFileDefinitionResponse;
}

interface ExportVM {
    format: AdpExportFormat;
    definition: AdpImportFileDefinitionSelectResponse;
}

// The result is a URL to download the exported document.
export type ModalResult = string;

export const AdpImportFileExporterModalComponent: IComponentOptions = {
    bindings: {
        resolve: "<",
        close: "&",
        dismiss: "&"
    },
    templateUrl,
    controller: class {
        resolve: ModalResolves;
        close: ValueEmitter<ModalResult>;
        dismiss: ValueEmitter<CancelValue>;

        export: ExportVM;

        constructor(private apexApiUrl: string) {
            'ngInject';
        }

        $onInit() {
            this.export = { format: AdpExportFormat.Default, definition: null }
            this.selectDefaultDefinitions(this.export.format);
        }

        onExport() {
            const format = this.resolve.exportFormats.find(p => p.format === this.export.format);
            const baseUrl = `${this.apexApiUrl}payrolls/${this.resolve.payrollID}/${format.apiExtension}`;
            const url = `${baseUrl}?definitionID=${this.export.definition.id}`
            // To export, resolve the modal with the value of the export URL.
            this.close({ $value: url });
        }

        onSelectExportFormat() {
            if (this.export.format) {
                this.selectDefaultDefinitions(this.export.format);
            }
        }

        private selectDefaultDefinitions(formatEnum: AdpExportFormat) {
            var defaultId = (this.resolve.defaultFormat?.id ?? 1);
            this.export.definition = this.resolve.earningsCodeDefinitions.reduce((result, config) => {
                if (result) {
                    return result;
                }
                if (config.id === defaultId) {
                    return config;
                }
                return null;
            }, null);
        }
    }
};

export const AdpImportFileExporterModal = {
    component: "apexAdpImportFileExporterModal",
    windowClass: 'xx-dialog pagespinner',
    size: 'sm',
    backdrop: 'static'
}
